import { render, staticRenderFns } from "./AddDrugBatch.vue?vue&type=template&id=696ab205&scoped=true&lang=pug&"
import script from "./AddDrugBatch.vue?vue&type=script&lang=ts&"
export * from "./AddDrugBatch.vue?vue&type=script&lang=ts&"
import style0 from "./AddDrugBatch.vue?vue&type=style&index=0&id=696ab205&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696ab205",
  null
  
)

export default component.exports